(function () {
  "use strict";

  var CFG = window.__florameWebPushConfig || {};
  var REGISTER_ENDPOINT = String(CFG.registerEndpoint || "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/registerMobilePushToken");
  var PUBLIC_CONFIG_ENDPOINT = String(CFG.publicConfigEndpoint || CFG.pushPublicConfigEndpoint || "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/customerPushPublicConfigV1");
  var INSTALL_ID_KEY = "florame_web_push_installation_id";
  var INSTALLED_KEY = "florame_pwa_installed_v1";
  var INSTALLED_AT_KEY = "florame_pwa_installed_at_v1";
  var PERMISSION_DISMISSED_KEY = "florame_web_push_permission_dismissed_v1";
  var PENDING_PERMISSION_KEY = "florame_web_push_pending_permission_v1";
  var INSTALL_DISMISSED_KEY = "florame_web_push_install_dismissed_v1";
  var SUB_HASH_KEY = "florame_web_push_subscription_hash";
  var PERMISSION_DISMISS_TTL_MS = 6 * 60 * 60 * 1000;
  var INSTALL_REMIND_TTL_MS = 3 * 24 * 60 * 60 * 1000;
  var INSTALL_MARK_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var DEFAULT_HOME = "/pages/home";
  var DEFAULT_LOGO = "https://florame.ai/cdn/shop/files/true-logo.webp?v=1770134712&width=512&height=512";
  var deferredInstallPrompt = null;
  var standalonePermissionTimer = 0;
  var pwaInstallWarmupPromise = null;
  var publicPushConfigPromise = null;

  window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    deferredInstallPrompt = event;
    markNotInstalled();
  });

  window.addEventListener("appinstalled", function () {
    markInstalled();
    setPendingPermission();
  });

  window.addEventListener("pageshow", function () {
    publishInstallState();
    scheduleStandalonePermissionPrompt();
  });

  window.addEventListener("focus", function () {
    publishInstallState();
    scheduleStandalonePermissionPrompt();
  });

  window.addEventListener("load", function () {
    scheduleStandalonePermissionPrompt();
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      publishInstallState();
      scheduleStandalonePermissionPrompt();
    }
  });

  function isFlorameHost() {
    var host = String(window.location.hostname || "").toLowerCase();
    return host === "florame.ai" || host.endsWith(".florame.ai") || host.indexOf("myshopify.com") !== -1;
  }

  function isAppleTouchDevice() {
    var ua = navigator.userAgent || "";
    return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  }

  function isAndroidDevice() {
    return /Android/i.test(navigator.userAgent || "");
  }

  function isMobileDevice() {
    return isAppleTouchDevice() || isAndroidDevice() || (navigator.maxTouchPoints > 0 && window.innerWidth <= 820);
  }

  function getPlatformName() {
    if (isAppleTouchDevice()) return "ios";
    if (isAndroidDevice()) return "android";
    return "web";
  }

  function isStandalone() {
    try {
      return window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
    } catch (_) {
      return window.navigator.standalone === true;
    }
  }

  function installPromptsEnabled() {
    return CFG.installPromptsEnabled !== false;
  }

  function pushSupported() {
    return "serviceWorker" in navigator && "Notification" in window && "PushManager" in window;
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key) || ""; } catch (_) { return ""; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, String(value || "")); } catch (_) {}
  }

  function storageRemove(key) {
    try { window.localStorage.removeItem(key); } catch (_) {}
  }

  function isInstallMarked() {
    if (storageGet(INSTALLED_KEY) !== "1") return false;
    var installedAt = Number(storageGet(INSTALLED_AT_KEY) || 0);
    if (!isStandalone() && installedAt && Date.now() - installedAt > INSTALL_MARK_TTL_MS) {
      storageRemove(INSTALLED_KEY);
      storageRemove(INSTALLED_AT_KEY);
      return false;
    }
    return true;
  }

  function markInstalled() {
    storageSet(INSTALLED_KEY, "1");
    storageSet(INSTALLED_AT_KEY, Date.now());
    storageRemove(INSTALL_DISMISSED_KEY);
    publishInstallState();
  }

  function markNotInstalled() {
    if (!isStandalone()) {
      storageRemove(INSTALLED_KEY);
      storageRemove(INSTALLED_AT_KEY);
    }
    publishInstallState();
  }

  function setPendingPermission() {
    storageSet(PENDING_PERMISSION_KEY, Date.now());
  }

  function clearPendingPermission() {
    storageRemove(PENDING_PERMISSION_KEY);
  }

  function hasPendingPermission() {
    return !!storageGet(PENDING_PERMISSION_KEY) || forcePromptRequested();
  }

  function publishInstallState() {
    try {
      var installed = isStandalone() || isInstallMarked();
      document.documentElement.setAttribute("data-florame-pwa-installed", installed ? "1" : "0");
      document.documentElement.setAttribute("data-florame-pwa-standalone", isStandalone() ? "1" : "0");
      document.documentElement.setAttribute("data-florame-pwa-installable", deferredInstallPrompt ? "1" : "0");
      window.dispatchEvent(new CustomEvent("florame:pwa-install-state", {
        detail: { installed: installed, standalone: isStandalone(), installable: !!deferredInstallPrompt }
      }));
    } catch (_) {}
  }

  function startUrl() {
    var raw = String(CFG.startUrl || DEFAULT_HOME);
    var joiner = raw.indexOf("?") === -1 ? "?" : "&";
    return raw + joiner + "florame_push=1&source=pwa_install";
  }

  function openInstalledApp(box) {
    setPendingPermission();
    if (box) {
      updatePrompt(
        box,
        t("Apro Florame", "Opening Florame"),
        t("Se resta qui, usa l'icona in Home.", "If it stays here, use the Home icon."),
        t("Apri", "Open"),
        "",
        t("App pronta", "App ready")
      );
    }
    try { window.location.assign(startUrl()); } catch (_) {}
  }

  function forcePromptRequested() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var raw = String(params.get("florame_push") || params.get("push") || "").toLowerCase();
      return raw === "1" || raw === "true" || raw === "force";
    } catch (_) {
      return false;
    }
  }

  function wasSnoozedRecently(key, ttl) {
    if (forcePromptRequested()) return false;
    var raw = Number(storageGet(key) || 0);
    return raw > 0 && Date.now() - raw < ttl;
  }

  function wasPermissionDismissedRecently() {
    return wasSnoozedRecently(PERMISSION_DISMISSED_KEY, PERMISSION_DISMISS_TTL_MS);
  }

  function wasInstallDismissedRecently() {
    return wasSnoozedRecently(INSTALL_DISMISSED_KEY, INSTALL_REMIND_TTL_MS);
  }

  function snoozeInstallPrompt() {
    storageSet(INSTALL_DISMISSED_KEY, Date.now());
  }

  function dismissPrompt(box) {
    var mode = box ? String(box.getAttribute("data-florame-web-push") || "") : "";
    storageSet(mode.indexOf("install") !== -1 ? INSTALL_DISMISSED_KEY : PERMISSION_DISMISSED_KEY, Date.now());
    if (box) box.remove();
  }

  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return "florame-web-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  function getInstallationId() {
    var id = storageGet(INSTALL_ID_KEY);
    if (id) return id;
    id = makeId();
    storageSet(INSTALL_ID_KEY, id);
    return id;
  }

  function getCustomerContext() {
    var customer = window.__loggedCustomer || {};
    var analyticsCustomer = "";
    try {
      analyticsCustomer = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId;
    } catch (_) {}
    return {
      customerId: String(CFG.customerId || customer.id || analyticsCustomer || storageGet("florame_customer_id") || ""),
      customerEmail: String(CFG.customerEmail || customer.email || storageGet("florame_customer_email") || "")
    };
  }

  function getCustomerLabel() {
    var customer = window.__loggedCustomer || {};
    var directName = String(CFG.customerFirstName || customer.firstName || customer.first_name || storageGet("florame_customer_first_name") || "").trim();
    if (directName) return directName.split(/\s+/)[0];
    var email = String(CFG.customerEmail || customer.email || storageGet("florame_customer_email") || "").trim();
    if (email && email.indexOf("@") > 1) return email.split("@")[0].split(/[._-]/)[0];
    return "";
  }

  function greeting() {
    var name = getCustomerLabel();
    if (name) return t("Ciao " + name + ", attiva gli avvisi", "Hi " + name + ", enable alerts");
    return t("Attiva gli avvisi", "Enable alerts");
  }

  function reasonCopy() {
    return t(
      "Ordini, consegne e sorprese utili. Niente rumore.",
      "Orders, deliveries, and useful surprises. No noise."
    );
  }

  function installTitle() {
    return isAppleTouchDevice()
      ? t("Aggiungi Florame al tuo iPhone", "Add Florame to your iPhone")
      : t("Scarica Florame", "Download Florame");
  }

  function installCopy() {
    return isAppleTouchDevice()
      ? t("Apri la guida iOS aggiornata: Florame ti mostra il passaggio giusto per il tuo dispositivo.", "Open the updated iOS guide: Florame shows the right step for your device.")
      : t("Un tap per bouquet, ordini e consegne.", "One tap for bouquets, orders, and deliveries.");
  }

  function postInstallCopy() {
    return isAppleTouchDevice()
      ? t("Ora apri Florame dall'icona Home.", "Now open Florame from the Home icon.")
      : t("Ora apri Florame dalla nuova icona.", "Now open Florame from the new icon.");
  }

  function getLang() {
    try {
      if (window.FlorameI18n && typeof window.FlorameI18n.getLanguage === "function") {
        return window.FlorameI18n.getLanguage() === "en" ? "en" : "it";
      }
    } catch (_) {}
    return String(document.documentElement.lang || navigator.language || "it").slice(0, 2).toLowerCase() === "en" ? "en" : "it";
  }

  function t(it, en) {
    return getLang() === "en" ? en : it;
  }

  function ensurePwaInstallElement() {
    var existing = document.getElementById("florame-pwa-install");
    if (existing) return existing;
    var el = document.createElement("pwa-install");
    el.id = "florame-pwa-install";
    el.setAttribute("manual-apple", "");
    el.setAttribute("manual-chrome", "");
    el.setAttribute("manifest-url", String(CFG.manifestUrl || "/manifest.json"));
    el.setAttribute("name", "Florame");
    el.setAttribute("description", t("Il bouquet dei tuoi sogni in un click.", "Your dream bouquet in one click."));
    el.setAttribute("icon", String(CFG.iconUrl || DEFAULT_LOGO));
    el.setAttribute("styles", JSON.stringify({ "--tint-color": "#ff4d75" }));
    el.addEventListener("pwa-install-success-event", function () {
      markInstalled();
      setPendingPermission();
    });
    document.body.appendChild(el);
    return el;
  }

  function waitForPwaInstallElement(el) {
    if (el && typeof el.showDialog === "function") return Promise.resolve(true);
    if (!window.customElements || typeof window.customElements.whenDefined !== "function") return Promise.resolve(false);
    return Promise.race([
      window.customElements.whenDefined("pwa-install").then(function () { return true; }).catch(function () { return false; }),
      new Promise(function (resolve) { window.setTimeout(function () { resolve(false); }, 5000); })
    ]);
  }

  function nextPaint() {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(resolve);
      });
    });
  }

  function removePwaInstallMainBrowserStep(el) {
    var root = el && el.shadowRoot ? el.shadowRoot : null;
    if (!root) return false;
    var safariIcon = root.querySelector(".install-dialog.apple:not(.desktop) .how-to-description .description-step #pwa-safari");
    var step = safariIcon && safariIcon.closest ? safariIcon.closest(".description-step") : null;
    if (!step) return false;
    step.remove();
    return true;
  }

  function makePwaInstallShowMoreStep() {
    var step = document.createElement("div");
    step.className = "description-step";
    step.setAttribute("data-florame-pwa-show-more-step", "true");
    step.innerHTML = [
      '<div class="svg-wrap">',
      '<svg id="florame-pwa-show-more" fill="currentColor" width="25" height="25" version="1.1" viewBox="0 0 512.011 512.011" style="display:block;margin:0 auto;">',
      '<g><g><path d="M505.755,123.592c-8.341-8.341-21.824-8.341-30.165,0L256.005,343.176L36.421,123.592c-8.341-8.341-21.824-8.341-30.165,0 s-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.462,0,10.923-2.091,15.083-6.251l234.667-234.667 C514.096,145.416,514.096,131.933,505.755,123.592z"></path></g></g>',
      '</svg>',
      '</div>',
      '<div class="step-text">' + t("Premi visualizza altro", "Tap View More") + '</div>'
    ].join("");
    return step;
  }

  function ensurePwaInstallShowMoreStep(el) {
    var root = el && el.shadowRoot ? el.shadowRoot : null;
    if (!root) return false;
    var description = root.querySelector(".install-dialog.apple:not(.desktop) .how-to-description");
    var shareIcon = description ? description.querySelector(".description-step #pwa-share") : null;
    var shareStep = shareIcon && shareIcon.closest ? shareIcon.closest(".description-step") : null;
    if (!description || !shareStep) return false;
    var step = description.querySelector("[data-florame-pwa-show-more-step]");
    if (!step) step = makePwaInstallShowMoreStep();
    if (shareStep.nextElementSibling !== step) {
      description.insertBefore(step, shareStep.nextElementSibling);
    }
    return true;
  }

  function watchPwaInstallDialog(el) {
    if (!el || el.__floramePwaInstallStepWatcher) return;
    var run = function () {
      removePwaInstallMainBrowserStep(el);
      ensurePwaInstallShowMoreStep(el);
    };
    var attach = function () {
      if (el.__floramePwaInstallStepWatcher) return true;
      if (!el.shadowRoot) return false;
      run();
      el.__floramePwaInstallStepWatcher = new MutationObserver(run);
      el.__floramePwaInstallStepWatcher.observe(el.shadowRoot, { childList: true, subtree: true });
      return true;
    };
    if (!attach()) {
      window.setTimeout(attach, 50);
      window.setTimeout(attach, 200);
      window.setTimeout(attach, 600);
    }
    window.setTimeout(run, 0);
    window.setTimeout(run, 150);
    window.setTimeout(run, 450);
    if (el.updateComplete && typeof el.updateComplete.then === "function") {
      el.updateComplete.then(run).catch(function () {});
    }
  }

  function warmPwaInstallElement() {
    if (!installPromptsEnabled() || !isAppleTouchDevice()) return Promise.resolve(false);
    if (pwaInstallWarmupPromise) return pwaInstallWarmupPromise;
    pwaInstallWarmupPromise = Promise.resolve()
      .then(function () {
        var el = ensurePwaInstallElement();
        return waitForPwaInstallElement(el).then(function (ready) {
          if (ready) watchPwaInstallDialog(el);
          return nextPaint().then(function () { return ready; });
        });
      })
      .catch(function () { return false; });
    return pwaInstallWarmupPromise;
  }

  async function showPwaInstallDialog() {
    var el = ensurePwaInstallElement();
    var ready = await waitForPwaInstallElement(el);
    if (!ready) return false;
    await nextPaint();
    try {
      watchPwaInstallDialog(el);
      if (deferredInstallPrompt && !isAppleTouchDevice()) {
        el.externalPromptEvent = deferredInstallPrompt;
      }
      if (el.removeAttribute) {
        el.removeAttribute("manual-how-to");
      }
      if (typeof el.showDialog === "function") {
        await el.showDialog();
        watchPwaInstallDialog(el);
        removePwaInstallMainBrowserStep(el);
        ensurePwaInstallShowMoreStep(el);
        return true;
      }
    } catch (_) {}
    return false;
  }

  function injectStyle() {
    if (document.getElementById("florame-web-push-style")) return;
    var style = document.createElement("style");
    style.id = "florame-web-push-style";
    style.textContent = [
      ".florame-web-push{position:fixed;left:12px;right:12px;top:calc(12px + env(safe-area-inset-top,0px));z-index:2147482500;display:flex;align-items:center;gap:12px;max-width:500px;margin:0 auto;padding:12px 12px 12px 11px;background:radial-gradient(circle at 86% 0%,rgba(255,77,117,.28),transparent 36%),radial-gradient(circle at 6% 96%,rgba(255,214,102,.20),transparent 34%),linear-gradient(145deg,rgba(255,255,255,.96),rgba(255,244,248,.90));color:#24151a;border:1px solid rgba(255,255,255,.78);border-radius:24px;box-shadow:0 42px 96px rgba(84,20,40,.24),0 18px 34px rgba(15,23,42,.16),inset 0 1px 0 rgba(255,255,255,.98),inset 0 -10px 24px rgba(255,77,117,.07);backdrop-filter:blur(22px) saturate(165%);-webkit-backdrop-filter:blur(22px) saturate(165%);font-family:inherit;box-sizing:border-box;overflow:hidden;transform:perspective(900px) rotateX(.8deg) translate3d(0,0,0);}",
      ".florame-web-push:before{content:\"\";position:absolute;inset:1px 1px auto 1px;height:50%;border-radius:23px 23px 46px 46px;background:linear-gradient(120deg,rgba(255,255,255,.82),rgba(255,255,255,0));pointer-events:none;}",
      ".florame-web-push:after{content:\"\";position:absolute;right:-30px;top:-38px;width:120px;height:120px;border-radius:999px;background:radial-gradient(circle,rgba(255,77,117,.24),rgba(255,77,117,0) 68%);filter:blur(.2px);pointer-events:none;}",
      ".florame-web-push__logo{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:15px;background:linear-gradient(145deg,#fff 0%,#fff3f7 48%,#ffe3eb 100%);border:1px solid rgba(255,77,117,.22);box-shadow:0 18px 34px rgba(196,29,75,.20),0 8px 14px rgba(15,23,42,.10),inset 0 1px 0 rgba(255,255,255,.96),inset 0 -5px 12px rgba(255,77,117,.10);flex:0 0 auto;overflow:hidden;}",
      ".florame-web-push__logo img{display:block;width:36px;height:36px;object-fit:contain;}",
      ".florame-web-push__copy{min-width:0;flex:1;}",
      ".florame-web-push__copy,.florame-web-push__actions{position:relative;z-index:1;}",
      ".florame-web-push__eyebrow{display:inline-flex;align-items:center;gap:5px;margin:0 0 5px;padding:4px 8px;border-radius:999px;background:rgba(255,77,117,.10);color:#c41d4b;font-size:10px;line-height:1;font-weight:900;letter-spacing:0;text-transform:uppercase;}",
      ".florame-web-push__title{font-size:14px;line-height:1.1;font-weight:950;letter-spacing:0;margin:0 0 3px;color:#24151a;}",
      ".florame-web-push__body{font-size:11.5px;line-height:1.28;margin:0;color:#6b273a;}",
      ".florame-web-push__actions{display:flex;align-items:center;gap:8px;flex-shrink:0;}",
      ".florame-web-push button{appearance:none;border:0;border-radius:999px;font:inherit;font-size:12px;line-height:1;font-weight:900;letter-spacing:0;min-height:38px;padding:0 14px;cursor:pointer;white-space:nowrap;}",
      ".florame-web-push__primary{background:linear-gradient(145deg,#ff86a8 0%,#ff4d75 55%,#d91855 100%);color:#fff;box-shadow:0 16px 28px rgba(255,77,117,.38),0 6px 12px rgba(109,12,45,.14),inset 0 1px 0 rgba(255,255,255,.42),inset 0 -3px 0 rgba(136,11,52,.20);text-shadow:0 1px 1px rgba(70,0,22,.16);}",
      ".florame-web-push__close{width:38px;padding:0!important;background:rgba(255,255,255,.66);color:#8a5965;border:1px solid rgba(255,77,117,.12)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.8);}",
      ".florame-web-push__status{font-size:11px;line-height:1.35;color:#9b5266;margin-top:5px;}",
      "[data-theme=\"dark\"] .florame-web-push{background:radial-gradient(circle at top right,rgba(255,77,117,.22),transparent 28%),radial-gradient(circle at bottom left,rgba(255,214,102,.13),transparent 30%),linear-gradient(135deg,rgba(35,38,48,.96),rgba(20,23,31,.97));color:#fff;border-color:rgba(255,255,255,.10);box-shadow:0 44px 96px rgba(0,0,0,.50),0 18px 34px rgba(0,0,0,.30);}",
      "[data-theme=\"dark\"] .florame-web-push__title{color:#fff;}[data-theme=\"dark\"] .florame-web-push__body{color:rgba(255,255,255,.78);}[data-theme=\"dark\"] .florame-web-push__status{color:rgba(255,255,255,.70);}",
      "@media (min-width:700px){.florame-web-push{left:auto;right:18px;top:18px;margin:0;}}",
      "@media (max-width:430px){.florame-web-push{align-items:flex-start;padding:12px;gap:10px;}.florame-web-push__actions{flex-direction:column;align-self:stretch;}.florame-web-push button{min-height:34px;padding:0 11px;font-size:11px;}.florame-web-push__close{width:34px;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function ensurePrompt(mode) {
    var existing = document.querySelector("[data-florame-web-push]");
    if (existing) {
      existing.setAttribute("data-florame-web-push", mode);
      return existing;
    }
    injectStyle();
    var box = document.createElement("div");
    box.className = "florame-web-push";
    box.setAttribute("data-florame-web-push", mode);
    var logoUrl = String(CFG.logoUrl || CFG.iconUrl || DEFAULT_LOGO);
    box.innerHTML = [
      '<div class="florame-web-push__logo" aria-hidden="true"><img src="' + logoUrl.replace(/"/g, "%22") + '" alt=""></div>',
      '<div class="florame-web-push__copy">',
      '<p class="florame-web-push__eyebrow" data-florame-web-push-eyebrow></p>',
      '<p class="florame-web-push__title" data-florame-web-push-title></p>',
      '<p class="florame-web-push__body" data-florame-web-push-body></p>',
      '<div class="florame-web-push__status" data-florame-web-push-status></div>',
      '</div>',
      '<div class="florame-web-push__actions">',
      '<button type="button" class="florame-web-push__primary" data-florame-web-push-primary></button>',
      '<button type="button" class="florame-web-push__close" aria-label="Chiudi" data-florame-web-push-close>x</button>',
      '</div>'
    ].join("");
    document.body.appendChild(box);
    box.querySelector("[data-florame-web-push-close]").addEventListener("click", function () {
      dismissPrompt(box);
    });
    return box;
  }

  function updatePrompt(box, title, body, action, status, eyebrow) {
    if (!box) return;
    box.querySelector("[data-florame-web-push-eyebrow]").textContent = eyebrow || "";
    box.querySelector("[data-florame-web-push-title]").textContent = title;
    box.querySelector("[data-florame-web-push-body]").textContent = body;
    box.querySelector("[data-florame-web-push-primary]").textContent = action;
    box.querySelector("[data-florame-web-push-status]").textContent = status || "";
  }

  function requestNotificationPermission() {
    var result = Notification.requestPermission();
    if (result && typeof result.then === "function") return result;
    return new Promise(function (resolve) {
      Notification.requestPermission(resolve);
    });
  }

  async function registerWorker() {
    var swUrl = String(CFG.serviceWorkerUrl || "");
    if (!swUrl) throw new Error("Service worker non configurato");
    return navigator.serviceWorker.register(swUrl);
  }

  function loadPublicPushConfig() {
    var inlineKey = String(CFG.vapidPublicKey || "").trim();
    if (inlineKey) return Promise.resolve({ enabled: true, vapidPublicKey: inlineKey });
    if (publicPushConfigPromise) return publicPushConfigPromise;
    publicPushConfigPromise = fetch(PUBLIC_CONFIG_ENDPOINT, {
      method: "GET",
      headers: { "Accept": "application/json" },
      credentials: "omit"
    })
      .then(function (response) { return response.json().catch(function () { return null; }); })
      .then(function (data) {
        if (!data || data.success === false) return {};
        return data.settings || {};
      })
      .catch(function () { return {}; });
    return publicPushConfigPromise;
  }

  function hasUsablePublicPushConfig(settings) {
    if (!settings || settings.enabled === false || settings.webPushEnabled === false) return false;
    return Boolean(String(settings.vapidPublicKey || CFG.vapidPublicKey || "").trim());
  }

  async function getVapidPublicKey() {
    var settings = await loadPublicPushConfig();
    if (!hasUsablePublicPushConfig(settings)) return "";
    return String(settings.vapidPublicKey || "").trim();
  }

  function urlBase64ToUint8Array(base64String) {
    var padding = "=".repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
  }

  async function subscribeIfConfigured(registration) {
    var publicKey = await getVapidPublicKey();
    if (!publicKey || !registration.pushManager) return null;
    var existing = await registration.pushManager.getSubscription();
    if (existing) return existing;
    return registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
  }

  async function registerSubscription(subscription, source) {
    if (!subscription) return null;
    var json = subscription.toJSON ? subscription.toJSON() : subscription;
    var token = JSON.stringify(json);
    var ctx = getCustomerContext();
    var response = await fetch(REGISTER_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "omit",
      body: JSON.stringify({
        token: token,
        provider: "webpush",
        appId: "florame.ai.pwa",
        platform: getPlatformName(),
        permission: Notification.permission,
        source: source || (getPlatformName() + "_pwa"),
        installationId: getInstallationId(),
        customerId: ctx.customerId,
        customerEmail: ctx.customerEmail,
        locale: getLang(),
        url: window.location.href,
        userAgent: navigator.userAgent || ""
      })
    });
    var data = await response.json().catch(function () { return null; });
    if (!response.ok || (data && data.success === false)) throw new Error((data && data.error) || "Registrazione notifica non riuscita");
    if (data && data.tokenHash) storageSet(SUB_HASH_KEY, data.tokenHash);
    return data;
  }

  async function showReadyNotification(registration) {
    if (!registration || typeof registration.showNotification !== "function") return;
    await registration.showNotification("Florame", {
      body: t("Notifiche attive.", "Notifications enabled."),
      icon: CFG.iconUrl || DEFAULT_LOGO,
      badge: CFG.iconUrl || DEFAULT_LOGO,
      tag: "florame-web-push-ready",
      data: { url: DEFAULT_HOME }
    });
  }

  async function enableNotifications(box) {
    var button = box.querySelector("[data-florame-web-push-primary]");
    button.disabled = true;
    updatePrompt(
      box,
      t("Notifiche Florame", "Florame notifications"),
      t("Richiesta permesso in corso.", "Permission request in progress."),
      t("Attiva", "Enable"),
      t("Apertura...", "Opening..."),
      t("Step 2 di 2", "Step 2 of 2")
    );
    try {
      var registration = await registerWorker();
      var permission = await requestNotificationPermission();
      if (permission !== "granted") {
        button.disabled = false;
        updatePrompt(
          box,
          t("Notifiche non attive", "Notifications not enabled"),
          t("Puoi riattivarle dalla tua app Florame.", "You can enable them from your Florame app."),
          t("Riprova", "Retry"),
          "",
          t("Avvisi Florame", "Florame alerts")
        );
        return;
      }
      clearPendingPermission();
      var subscription = await subscribeIfConfigured(registration);
      if (!subscription) throw new Error(t("Notifiche Florame non configurate.", "Florame notifications are not configured."));
      await registerSubscription(subscription, getPlatformName() + "_pwa_permission");
      await showReadyNotification(registration).catch(function () {});
      updatePrompt(
        box,
        t("Notifiche attive", "Notifications enabled"),
        t("Perfetto, ti avvisiamo solo quando conta.", "Done, we only alert you when it matters."),
        "OK",
        t("Pronta.", "Ready."),
        t("Tutto pronto", "All set")
      );
      var doneButton = box.querySelector("[data-florame-web-push-primary]");
      var cleanButton = doneButton.cloneNode(true);
      cleanButton.disabled = false;
      doneButton.parentNode.replaceChild(cleanButton, doneButton);
      cleanButton.addEventListener("click", function () {
        box.remove();
      }, { once: true });
    } catch (error) {
      button.disabled = false;
      updatePrompt(
        box,
        t("Notifiche non disponibili", "Notifications unavailable"),
        isAppleTouchDevice()
          ? t("Apri Florame dall'icona in Home e riprova: Apple abilita gli avvisi da li'.", "Open Florame from the Home Screen icon and retry: Apple enables alerts there.")
          : t("Apri Florame dalla Home e riprova.", "Open Florame from Home and retry."),
        t("Riprova", "Retry"),
        error && error.message ? error.message : "",
        t("Avvisi Florame", "Florame alerts")
      );
    }
  }

  async function unregisterSubscription(subscription, source) {
    if (!subscription) return null;
    var json = subscription.toJSON ? subscription.toJSON() : subscription;
    var token = JSON.stringify(json);
    var ctx = getCustomerContext();
    var response = await fetch(REGISTER_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "omit",
      body: JSON.stringify({
        token: token,
        provider: "webpush",
        appId: "florame.ai.pwa",
        platform: getPlatformName(),
        enabled: false,
        permission: "Notification" in window ? Notification.permission : "",
        source: source || "storefront_menu_toggle_off",
        installationId: getInstallationId(),
        customerId: ctx.customerId,
        customerEmail: ctx.customerEmail,
        locale: getLang(),
        url: window.location.href,
        userAgent: navigator.userAgent || ""
      })
    });
    var data = await response.json().catch(function () { return null; });
    if (!response.ok || (data && data.success === false)) throw new Error((data && data.error) || "Disattivazione notifica non riuscita");
    storageRemove(SUB_HASH_KEY);
    return data;
  }

  async function getSubscriptionStatus() {
    var supported = pushSupported();
    var permission = "Notification" in window ? Notification.permission : "unsupported";
    var installed = isStandalone() || isInstallMarked();
    var status = {
      supported: supported,
      permission: permission,
      installed: installed,
      standalone: isStandalone(),
      subscribed: false,
      tokenHash: storageGet(SUB_HASH_KEY),
      platform: getPlatformName()
    };
    if (!supported) return status;
    try {
      var registration = await navigator.serviceWorker.getRegistration();
      if (!registration && installed) registration = await registerWorker().catch(function () { return null; });
      var subscription = registration && registration.pushManager
        ? await registration.pushManager.getSubscription()
        : null;
      status.subscribed = !!subscription && permission === "granted";
    } catch (_) {}
    return status;
  }

  function publishPushState() {
    getSubscriptionStatus()
      .then(function (state) {
        window.dispatchEvent(new CustomEvent("florame:web-push-state", { detail: state }));
      })
      .catch(function () {});
  }

  async function enableNotificationsFromMenu() {
    if (!pushSupported()) throw new Error(t("Notifiche non supportate su questo dispositivo.", "Notifications are not supported on this device."));
    if (isAppleTouchDevice() && !isStandalone()) {
      showInstallPrompt(getPlatformName(), true);
      throw new Error(t("Apri Florame dall'icona in Home e riprova.", "Open Florame from the Home Screen icon and retry."));
    }
    var registration = await registerWorker();
    var permission = await requestNotificationPermission();
    if (permission !== "granted") throw new Error(t("Permesso notifiche non concesso.", "Notification permission was not granted."));
    clearPendingPermission();
    var subscription = await subscribeIfConfigured(registration);
    if (!subscription) throw new Error(t("Notifiche Florame non configurate.", "Florame notifications are not configured."));
    await registerSubscription(subscription, "storefront_menu_toggle_on");
    await showReadyNotification(registration).catch(function () {});
    publishPushState();
    return getSubscriptionStatus();
  }

  async function disableNotificationsFromMenu() {
    if (!pushSupported()) return getSubscriptionStatus();
    var registration = await navigator.serviceWorker.getRegistration().catch(function () { return null; });
    if (!registration) registration = await registerWorker().catch(function () { return null; });
    var subscription = registration && registration.pushManager
      ? await registration.pushManager.getSubscription().catch(function () { return null; })
      : null;
    if (subscription) {
      await unregisterSubscription(subscription, "storefront_menu_toggle_off");
      await subscription.unsubscribe().catch(function () {});
    } else {
      storageRemove(SUB_HASH_KEY);
    }
    clearPendingPermission();
    publishPushState();
    return getSubscriptionStatus();
  }

  function setNotificationsEnabledFromMenu(enabled) {
    return enabled ? enableNotificationsFromMenu() : disableNotificationsFromMenu();
  }

  async function fallbackInstallAttempt(box) {
    if (!box) box = ensurePrompt(getPlatformName() + "-install-fallback");
    setPendingPermission();
    if (isAndroidDevice()) {
      updatePrompt(
        box,
        t("Ops, forse Florame e' gia' installata", "Oops, Florame may already be installed"),
        t("Il prompt di installazione non si e' aperto. Se l'hai gia' aggiunta, aprila dalla Home. Altrimenti usa il menu del browser.", "The install prompt did not open. If you already added it, open it from Home. Otherwise use the browser menu."),
        "OK",
        "",
        t("Installa Florame", "Install Florame")
      );
      box.querySelector("[data-florame-web-push-primary]").addEventListener("click", function () {
        snoozeInstallPrompt();
        box.remove();
      }, { once: true });
      return;
    }
    updatePrompt(
      box,
      isAppleTouchDevice() ? t("3 mosse su iPhone", "3 steps on iPhone") : t("Installa Florame", "Install Florame"),
      isAppleTouchDevice()
        ? t("Usa il comando del browser per aggiungere Florame alla schermata Home, poi aprila dall'icona.", "Use your browser's command to add Florame to the Home Screen, then open it from the icon.")
        : t("Il prompt nativo non e' disponibile in questo browser.", "The native prompt is not available in this browser."),
      "OK",
      "",
      t("Installa Florame", "Install Florame")
    );
    box.querySelector("[data-florame-web-push-primary]").addEventListener("click", function () {
      snoozeInstallPrompt();
      box.remove();
    }, { once: true });
  }

  async function promptAndroidNativeInstall(box) {
    if (!deferredInstallPrompt) {
      await fallbackInstallAttempt(box);
      return;
    }
    var promptEvent = deferredInstallPrompt;
    deferredInstallPrompt = null;
    try {
      await promptEvent.prompt();
      var choice = promptEvent.userChoice && typeof promptEvent.userChoice.catch === "function"
        ? await promptEvent.userChoice.catch(function () { return null; })
        : null;
      if (choice && choice.outcome === "dismissed") {
        snoozeInstallPrompt();
        if (box) box.remove();
        return;
      }
      markInstalled();
      setPendingPermission();
      snoozeInstallPrompt();
      if (box) box.remove();
    } catch (_) {
      await fallbackInstallAttempt(box);
    }
  }

  async function promptInstall(box) {
    if (isAndroidDevice()) {
      await promptAndroidNativeInstall(box);
      return;
    }
    var shown = await showPwaInstallDialog();
    if (shown) {
      setPendingPermission();
      snoozeInstallPrompt();
      if (box) box.remove();
      return;
    }
    await fallbackInstallAttempt(box);
  }

  async function showInstallPrompt(platform, force) {
    if (!installPromptsEnabled()) return;
    if (!force && wasInstallDismissedRecently()) return;
    if (platform === "android" && !force) return;
    await promptInstall(null);
  }

  async function showPermissionPrompt() {
    if (!isStandalone()) {
      if (installPromptsEnabled()) showInstallPrompt(getPlatformName());
      return;
    }
    var publicSettings = await loadPublicPushConfig();
    if (!hasUsablePublicPushConfig(publicSettings)) return;
    if (!hasPendingPermission() && wasPermissionDismissedRecently()) return;
    if (Notification.permission === "granted") {
      registerWorker().then(function (registration) {
        return subscribeIfConfigured(registration).then(function (subscription) {
          return registerSubscription(subscription, getPlatformName() + "_pwa_refresh");
        });
      }).catch(function () {});
      return;
    }
    if (Notification.permission === "denied") return;
    var box = ensurePrompt(getPlatformName() + "-permission");
    updatePrompt(
      box,
      greeting(),
      reasonCopy(),
      t("Attiva avvisi", "Enable alerts"),
      "",
      t("Step 2 di 2", "Step 2 of 2")
    );
    box.querySelector("[data-florame-web-push-primary]").onclick = function () {
      enableNotifications(box);
    };
  }

  function scheduleStandalonePermissionPrompt() {
    if (!isStandalone() || !pushSupported()) return;
    if (standalonePermissionTimer) window.clearTimeout(standalonePermissionTimer);
    standalonePermissionTimer = window.setTimeout(function () {
      standalonePermissionTimer = 0;
      if (!isStandalone() || !pushSupported()) return;
      markInstalled();
      registerWorker().catch(function () {});
      showPermissionPrompt();
    }, 320);
  }

  function bindInstallTriggers() {
    document.addEventListener("click", function (event) {
      var target = event.target;
      var trigger = target && target.closest ? target.closest("[data-florame-pwa-install-trigger]") : null;
      if (!trigger) return;
      event.preventDefault();
      if (!installPromptsEnabled()) return;
      if (isStandalone()) {
        showPermissionPrompt();
        return;
      }
      trigger.setAttribute("aria-busy", "true");
      warmPwaInstallElement()
        .then(function () { return showInstallPrompt(getPlatformName(), true); })
        .finally(function () { trigger.removeAttribute("aria-busy"); });
    });
  }

  function resolvePrinterApkUrl() {
    return window.location.origin + "/cdn/shop/t/93/assets/florame-printer-latest.apk";
  }

  function normalizePrinterDownloadLinks() {
    var links = document.querySelectorAll('a[href*="florame-printer-v1.6."]');
    links.forEach(function (link) {
      link.href = resolvePrinterApkUrl();
      link.setAttribute("download", "");
    });
  }

  function bindPrinterDownloadFallback() {
    normalizePrinterDownloadLinks();
    document.addEventListener("click", function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a[href*="florame-printer-v1.6."]') : null;
      if (!link) return;
      link.href = resolvePrinterApkUrl();
    }, true);
  }

  function init() {
    if (!isFlorameHost()) return;
    publishInstallState();
    if (!installPromptsEnabled()) {
      if (isStandalone() && pushSupported()) {
        markInstalled();
        registerWorker().catch(function () {});
        scheduleStandalonePermissionPrompt();
      }
      return;
    }
    if (!isMobileDevice() && !forcePromptRequested()) return;
    var platform = getPlatformName();
    warmPwaInstallElement();
    if (!isStandalone()) {
      if (!isInstallMarked()) showInstallPrompt(platform);
      return;
    }
    markInstalled();
    if (pushSupported()) {
      registerWorker().catch(function () {});
      scheduleStandalonePermissionPrompt();
      return;
    }
    if (platform === "android") showInstallPrompt("android");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindInstallTriggers();
      bindPrinterDownloadFallback();
      init();
    });
  } else {
    bindInstallTriggers();
    bindPrinterDownloadFallback();
    init();
  }

  window.FlorameWebPush = {
    isAppleTouchDevice: isAppleTouchDevice,
    isAndroidDevice: isAndroidDevice,
    isStandalone: isStandalone,
    isInstalled: function () { return isStandalone() || isInstallMarked(); },
    pushSupported: pushSupported,
    showInstall: function () {
      showInstallPrompt(getPlatformName(), true);
    },
    openInstalledApp: openInstalledApp,
    status: getSubscriptionStatus,
    setEnabled: setNotificationsEnabledFromMenu,
    disable: disableNotificationsFromMenu,
    showPrompt: function () {
      if (!isStandalone()) showInstallPrompt(getPlatformName(), true);
      else if (pushSupported()) showPermissionPrompt();
      else showInstallPrompt(getPlatformName());
    },
    enable: function () {
      if (!isStandalone()) {
        showInstallPrompt(getPlatformName(), true);
        return Promise.resolve(null);
      }
      var box = ensurePrompt("manual");
      return enableNotifications(box);
    }
  };
})();
